import type { MutateOptions } from "./index.js"

/** The per-call options for a write only admins may make (MutateOptions). Its own
 *  module so the services can import it without a cycle through index.ts. */
export const AS_ADMIN: MutateOptions = { role: "admin" }
